export default __webpack_public_path__ + "static/media/ownerrez_step4.e8440d5b.jpg";